module.exports = __webpack_public_path__ + "img/horizontal.51eb3c3a.png";